class PartnerListMore extends HTMLElement {
  connectedCallback() {
    this.buttons = this.querySelectorAll('.partner-list__more');
    this.onClick = () => this.classList.add('is-expanded');
    this.buttons.forEach((button) => button.addEventListener('click', this.onClick));
  }

  disconnectedCallback() {
    this.buttons?.forEach((button) => button.removeEventListener('click', this.onClick));
  }
}

if (!customElements.get('partner-list-more')) {
  customElements.define('partner-list-more', PartnerListMore);
}
